import React, { useState, useEffect } from 'react';

const DisplayTime = () => {
    const [time, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000); // update every second

        return () => clearInterval(timer);
    }, []);

    const hours24 = time.getHours();
    const hours12 = hours24 % 12 || 12; // change from 24 hours to 12
    const ampm = hours24 >= 12 ? 'PM' : 'AM';
    const min = time.getMinutes().toString().padStart(2, '0');
    const sec = time.getSeconds().toString().padStart(2, '0');

    return (
        <h1>It is currently {hours12}:{min}:{sec} {ampm}</h1>
    );
};

export default DisplayTime;
